import { render } from "./Finalidade.vue?vue&type=template&id=11433db3&scoped=true"
import script from "./Finalidade.vue?vue&type=script&lang=js"
export * from "./Finalidade.vue?vue&type=script&lang=js"

import "./Finalidade.vue?vue&type=style&index=0&id=11433db3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11433db3"]])

export default __exports__